/** The AI debug panel's model call list (staff only). */
export const translationsDashboard_sv_aiModelCalls = {
  aiModelCallsTitle: "Modellanrop",
  aiModelCallsLoading: "Läser in modellanrop",
  aiModelCallsError: "Det gick inte att läsa in modellanropen.",
  aiModelCallsEmpty:
    "Inga modellanrop har registrerats för detta meddelande. Anrop sparas i 30 dagar.",
  aiModelCallFallback: "Reserv",
  aiModelCallTokensIn: "In",
  aiModelCallTokensOut: "Ut",
  aiModelCallTokensCached: "Cachade",
  aiModelCallLoading: "Läser in anrop",
  aiModelCallError: "Det gick inte att läsa in anropet.",
  aiModelCallTruncated:
    "Det sparade innehållet förkortades: {{instruction}} tecken togs bort från slutet av instruktionen och {{response}} från svaret.",
  aiModelCallInstruction: "Instruktion",
  aiModelCallCopyInstruction: "Kopiera instruktion",
  aiModelCallInput: "Indata",
  aiModelCallCopyInput: "Kopiera indata",
  aiModelCallConversation: "Konversationen som den skickades",
  aiModelCallNoConversation: "Inga konversationsmeddelanden skickades.",
  aiModelCallMessageUser: "Användare",
  aiModelCallMessageModel: "Modell",
  aiModelCallResponse: "Rått svar",
  aiModelCallCopyResponse: "Kopiera rått svar",
  aiModelCallCopied: "Kopierat",
  aiModelCallReplayTitle: "Kör igen",
  aiModelCallEditInstruction: "Redigera instruktion",
  aiModelCallReplayInstructionLabel: "Instruktion för omkörningen",
  aiModelCallReplayButton: "Kör igen",
  aiModelCallReplaying: "Kör igen...",
  aiModelCallReplayRateLimited:
    "För många omkörningar. Du kan köra om 10 anrop per minut och 200 per dag.",
  aiModelCallReplayTooLong: "Instruktionen är för lång för att köras om (högst 400 000 tecken).",
  aiModelCallReplayUnsupported: "Omkörning är inte tillgänglig för AWS Bedrock-anrop.",
  aiModelCallReplayFailed: "Omkörningen misslyckades. Försök igen senare.",
  aiModelCallOriginalResponse: "Ursprungligt rått svar",
  aiModelCallReplayAnswer: "Nytt svar",
  aiModelCallCopyReplayAnswer: "Kopiera nytt svar",
  aiModelCallDuration: "Tid",
  aiModelCallRoleRouting: "Fördelning",
  aiModelCallRoleRephrase: "Omformulering",
  aiModelCallRoleMetadata: "Metadatafilter",
  aiModelCallRoleLanguage: "Språkidentifiering",
  aiModelCallRoleRag: "Svar med kunskap",
  aiModelCallRoleSimple: "Enkelt svar",
  aiModelCallRoleImage: "Bildsvar",
  aiModelCallRoleSuggestion: "Föreslagna frågor",
  aiModelCallRolePlanner: "API-planerare",
  aiModelCallRoleAnswer: "Svar",
};
